import { useDevice } from '.';
interface CoreHookReturn {
  gotoPtEApp: (isSSORedirect?: boolean) => void;
}
export const useCore = (): CoreHookReturn => {
  const isApp = useDevice().isApp;
  const gotoPtEApp = (isSSORedirect?: boolean) => {
    //   console.trace();
    if (isApp) {
      window.location.href = `../index.html`;
    } else if (isSSORedirect) {
      window.location.href = `${import.meta.env.VITE_PTE_URL}/sso/subscription?d=${new Date().getTime()}`;
    } else {
      window.location.href = `${import.meta.env.VITE_PTE_URL}?d=${new Date().getTime()}`;
    }
  };

  return {
    gotoPtEApp,
  };
};
